import React from 'react';
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from '@mui/material';
import {
  Restaurant,
  EventSeat,
  Schedule,
  Security,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const features = [
    {
      icon: <EventSeat sx={{ fontSize: 40 }} />,
      title: 'Easy Booking',
      description: 'Book your table in just a few clicks with our intuitive interface.',
    },
    {
      icon: <Schedule sx={{ fontSize: 40 }} />,
      title: 'Real-time Availability',
      description: 'See real-time table availability and choose your preferred time slot.',
    },
    {
      icon: <Restaurant sx={{ fontSize: 40 }} />,
      title: 'Premium Experience',
      description: 'Enjoy a seamless dining experience with our premium MVE System v2.0',
    },
    {
      icon: <Security sx={{ fontSize: 40 }} />,
      title: 'Secure & Reliable',
      description: 'Your data is safe with our secure authentication and booking system.',
    },
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 8,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h2" component="h1" gutterBottom>
            Welcome to MVE Table Booking System
          </Typography>
       
          <Box sx={{ mt: 4 }}>
            {isAuthenticated ? (
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={() => navigate('/book-table')}
                sx={{ mr: 2 }}
              >
                Book a Table
              </Button>
            ) : (
              <>
            
                <Button
                  variant="outlined"
                  color="inherit"
                  size="large"
                  onClick={() => navigate('/login')}
                >
                  Sign In
                </Button>
              </>
            )}
          </Box>
        </Container>
      </Box>

     

     
    </Box>
  );
};

export default Home; 